module.exports = __webpack_public_path__ + "static/media/car-marker-offline.368632b2.png";